import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef } from 'react';

const Successpop = ({ duration = 2, onClose, displayText }) => {
  const timerId = useRef(null);

  useEffect(() => {
    timerId.current = setTimeout(() => {
      onClose();
    }, duration * 1000);

    return () => timerId.current && clearTimeout(timerId.current);
  }, []);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex justify-center items-center">
      <div className="flex flex-col justify-center items-center gap-4 px-6 py-5 text-4xl text-primary bg-white rounded-lg shadow-lg w-[301px] h-[190px] max-w-xs sm:max-w-sm md:max-w-md">
        <FontAwesomeIcon icon={faCircleCheck} className="text-primary text-5xl" />
        <p className="text-primary text-base font-semibold text-center">{displayText}</p>
      </div>
    </div>
  );
};

export default Successpop;
